import styled, { css } from 'styled-components';

const defaultWrapperWidth = '498px';

export const Form = styled.form`
  position: relative;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 12px;
  margin: 16px 0px 0px;
  max-width: ${defaultWrapperWidth};
`;

export const CheckboxWrapper = styled(InputWrapper)`
  margin: 0px;
  max-width: unset;
`;

export const CheckboxLabel = styled.label`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  margin: 0px 0px 4px;

  label {
    width: 19px;
    height: 19px;
  }
`;

export const Text = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: inline-block;
    font-family: ${theme.v2.font.family.primary};
    font-size:  ${theme.v2.font.sizes.xxs};
    gap: 6px;
    line-height: ${theme.v2.font.lineHeight.text};

    p {
      margin: 0px;
    }

    a {
      font-size:  ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const Info = styled.p`
  ${({ theme, maxWidth }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.family.medium};
    line-height: 24px;
    max-width: ${maxWidth && `${maxWidth}px`};
    margin: 0px;
    margin-top: 15px;
  `}
`;

export const ButtonWrapper = styled.div`
  margin-bottom: 8px;
`;

export const FileButton = styled.label`
  ${({ theme, file }) => css`
    align-items: center;
    background-color:${file ? theme.v2.colors.feedback.activeLight : theme.v2.colors.white.primary};
    border-color: ${file ? theme.v2.colors.feedback.activeLight : theme.v2.colors.brand.primaryMedium};
    border-radius: 50px;
    border-style: dashed;
    border-width: 2px;
    color: ${file ? theme.v2.colors.white.primary : theme.v2.colors.brand.primaryMedium};
    cursor: pointer;
    display: inline-flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.family.medium};
    height: 48px;
    lin-height: ${theme.v2.font.lineHeight.text};
    padding: 16px 24px;
    transition:background-color 150ms ease-in-out, border 150ms ease-in-out, color 150ms ease-in-out;

    &:hover {
      border-color: ${theme.v2.colors.brand.primaryMedium};
      background-color: ${theme.v2.colors.brand.primaryMedium};
      color: ${theme.v2.colors.white.primary};
    }
  `}
`;

export const FileDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size:  ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
    margin-top: 6px;
  `}
`;

export const FileInput = styled.input`
  display: none;
`;

export const FileInputExtensions = styled.div`
  ${({ theme }) => css`
    padding: 8px 0;
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    margin-left: 16px;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    max-width: 288px;
  `}
`;

export const FileWrapper = styled.div`
  margin-top: 8px;
  display: flex;
`;

export const SelectWrapper = styled.div`
  margin: -4px 0px 4px;
  max-width: ${defaultWrapperWidth};
`;

export const AlertWrapper = styled.div`
  margin-bottom: 4px;
  margin-top: 4px;
`;

export const Divider = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highMedium};
    height: 1px;
    margin: 35px 0px 25px;
    width: 100%;
  `}
`;

export const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 29px;
`;
